import React, { useState, useCallback, useMemo } from "react";

import { Table } from "components";
import { useTableProps } from "hooks";

import HistoryQueueContext from "./historyQueueContext";

type HistoryTableProps = {
	id: number | string;
	historyKey: string;
	classNameHeader?: string;
	tableClassName?: string;
	getHistoryList: Function;
	columns: any;
};

const HistoryTable = ({
	id,
	historyKey,
	getHistoryList,
	columns,
	classNameHeader,
	tableClassName,
}: HistoryTableProps) => {
	const [fetchData, setFetchData] = useState({
		page: 0,
	});

	const queryResult = getHistoryList?.({ historyKey, fetchData, id });
	const { meta, data, refetch } = useTableProps(queryResult);

	const initialState = useMemo(
		() => ({
			pageIndex: fetchData.page,
		}),
		[fetchData],
	);

	const handlePageChange = useCallback(
		({ pageIndex }) => {
			if (pageIndex !== fetchData.page)
				setFetchData({ ...fetchData, page: pageIndex });
		},
		[fetchData],
	);

	return (
		<HistoryQueueContext.Provider value={{ refetch }}>
			<Table
				columns={columns}
				meta={meta}
				data={data}
				classNameHeader={classNameHeader}
				handlePageChange={handlePageChange}
				initialState={initialState}
				className={`${tableClassName} ${"mt-4"}`}
				stickyFooter
				stickyHeader
				compact
			/>
		</HistoryQueueContext.Provider>
	);
};

export default HistoryTable;
